import TargetList from 'components/branch/target/TargetList';
import TargetMenu from 'components/branch/target/TargetMenu';
import MainTitle from 'components/common/admin/MainTitle';
import { useIntl } from 'react-intl';
import "./Conf.scss";

export default function Examtemplate(props: any) {
  const { formatMessage } = useIntl();
  

  return (
    <div className="admin-basic-conf table">
      <MainTitle type="table" title={formatMessage({ id: 'Name_4', defaultMessage: '대상자' })}>
        <TargetMenu />
      </MainTitle>
      <div className="react-table-area">
        <TargetList />
      </div>
    </div>
  );
}